module.exports = __webpack_public_path__ + "img/1552114532.e25a291c.jpg";